'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from 'next/image';
import Link from 'next/link';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { usePathname } from 'next/navigation';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function DynamicLogo({ generalLayout }: { generalLayout: GeneralLayout['data'] }) {
  const pathname = usePathname();

  const isWinery = pathname === '/vinarstvo';

  return (
    <Link
      prefetch={false}
      href={'/'}
      className="ea-header-main__logo flex h-[72px] w-[86px] shrink-0 items-center justify-center sm:h-[120px] sm:w-[144px]"
    >
      <Image
        src={
          isWinery
            ? '/images/vinarstvo-logo.png'
            : (generalLayout.header?.logo?.url ?? '/images/placeholder.png')
        }
        alt={resolveImageAlt(
          isWinery ? undefined : generalLayout?.header?.logo,
          (generalLayout?.site_name?.trim() || ''),
        )}
        width={144}
        height={120}
        className={cn('w-full object-contain', isWinery ? 'h-16 sm:h-20' : 'h-full')}
        sizes="(max-width: 639px) 86px, 144px"
      />
    </Link>
  );
}
